module.exports = __webpack_public_path__ + "img/marco-arana-Recovered.dadfa505.png";